module.exports = "<router-outlet></router-outlet>\r\n<ngx-ui-loader></ngx-ui-loader>"